import React from "react"
import store from "store"
import $ from "jquery"
import Page from "../Page"
import { API_PROFILE_BASE_URL, CheckAuth, BASE_URL, API_PROGRAM } from "../Util"
import { Row, Col, Modal, Button, Preloader } from "react-materialize"
import { notify } from "react-notify-toast"
import CourseItem from "../common/CourseItem"
import LoginSmile from "./../Auth/components/LoginSmile"
import { Link } from "react-router-dom"

class Profile extends Page {
  constructor(props) {
    super(props)
    this.state = {
      data: null,
      enrolled_courses: null,
      completed_courses: null,
      favourite_courses: null,
      events_ticket: null,
      coupons: null,
      favourite_learning_path: null,
      optionPrograms: [],
    }
  }

  componentDidMount() {
    this.handleLoadData()
    this.getPrograms()
  }

  handleLoadData = (e) => {
    $.getJSON(API_PROFILE_BASE_URL).then((data) => {
      this.setState({ data: data.payload })

      let promoKey = "promo_seen_" + data.payload.uuid
      let isPromoSeen = store.get(promoKey)

      if (data.payload.voucher_deposit > 0 && !isPromoSeen) {
        // $("#promo-btn").trigger("click");
        store.set(promoKey, true)
      }
    })

    $.getJSON(API_PROFILE_BASE_URL + "/courses/enrollment").then((data) => {
      this.setState({ enrolled_courses: data.data.payload })
    })

    $.getJSON(API_PROFILE_BASE_URL + "/courses/completed").then((data) => {
      this.setState({ completed_courses: data.payload })
    })

    $.getJSON(API_PROFILE_BASE_URL + "/events/ticket").then((data) => {
      this.setState({ events_ticket: data.payload }, () => {
        console.log("EVENT TICKET >>> ", this.state.events_ticket)
      })
    })

    $.getJSON(API_PROFILE_BASE_URL + "/coupons/list").then((data) => {
      this.setState({ coupons: data.payload })
    })

    $.getJSON(API_PROFILE_BASE_URL + "/learningpaths/followed").then((data) => {
      this.setState({ favourite_learning_path: data.payload })
    })
  }

  handleSubmitForm(values) {
    $.post(API_PROFILE_BASE_URL + "/sync-smile", {
      username: values["username"],
      password: values["password"],
      program_id: values["programId"],
    })
      .then((data) => {
        let existingUserData = store.get("userdata")
        notify.show("Berhasil menghubungkan Akun", "success")
        store.set("userdata", { ...existingUserData, ...data.payload })
        window.location.reload()
      })
      .fail((XMLHttpRequest) => {
        let response

        try {
          response = JSON.parse(XMLHttpRequest.responseText)
        } catch (e) {}

        if (response && response.status) {
          notify.show("Failed", "warning")
          // notify.show(response.message, "warning");
        }
      })
  }

  getPrograms = () => {
    $.get(API_PROGRAM + "?isProfile=1").then((data) => {
      if (data.payload) {
        let options = [...data.payload]
        options =
          options
            .filter((opt) => opt.has_url)
            .map((obj) => ({
              label: obj.name,
              value: obj.id,
            })) || []

        this.setState({ optionPrograms: options })
      }
    })
  }

  render() {
    var { data, optionPrograms } = this.state
    if (!data) {
      return super.render()
    }

    let learningPathFavorite = this.state.favourite_learning_path

    data.enrolled_courses = this.state.enrolled_courses
    data.favourite_courses = this.state.favourite_courses
    data.completed_courses = this.state.completed_courses
    data.events_ticket = this.state.events_ticket
    data.coupons = this.state.coupons

    return (
      <div>
        <div className="container bg-academia font-white">
          <div className="mb-0">
            <div m={1} s={12} className="profile-avatar">
              <img src={CheckAuth().foto} className="small circle mr-s" />
            </div>
            <div m={11} s={12}>
              <div className="profile-info">
                <div className="name">{data.name}</div>
                <div className="email">{data.email}</div>

                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {data.smile_id && data.profile_array.length > 0
                    ? data.profile_array.map((row, index) => {
                        return (
                          <div
                            key={index}
                            style={{
                              marginRight: "48px",
                              marginTop: "24px",
                            }}
                          >
                            <div style={{ display: "flex", flexWrap: "nowrap" }}>
                              <div className="label">Tipe Entitas:</div>
                              <div className="value">
                                {row.entity_type && row.entity_type.name
                                  ? row.entity_type.name
                                  : null}
                              </div>
                            </div>
                            <div style={{ display: "flex", flexWrap: "nowrap" }}>
                              <div className="label">Program:</div>
                              <div className="value">
                                {row.program && row.program.name ? row.program.name : null}
                              </div>
                            </div>
                            <div style={{ display: "flex", flexWrap: "nowrap" }}>
                              <div className="label">Smile Username:</div>
                              <div className="value">{row.smile_username}</div>
                            </div>
                          </div>
                        )
                      })
                    : null}
                </div>

                <div style={{ display: "flex", gap: "8px" }}>
                  <Link
                    to={`/profile/edit`}
                    style={{ marginTop: "14px" }}
                    className="outline-white-button"
                  >
                    Ubah Profil
                  </Link>
                  {optionPrograms.length >= 1 ? (
                    <div>
                      <button
                        type="button"
                        style={{ marginTop: "14px" }}
                        className="white-button"
                        onClick={(e) => $("#trigger-modal-email").trigger("click")}
                      >
                        Hubungkan dengan Akun SMILE
                      </button>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container" style={{ marginTop: "32px" }}>
          <h5 className="mb-s">Kursus Saya</h5>
          <div className="product-container">
            {data.enrolled_courses &&
              data.enrolled_courses.map((item, i) => {
                return (
                  <CourseItem
                    key={"user-course-" + i}
                    data={item}
                    progress={data.enrolled_courses.progress}
                  />
                )
              })}
          </div>

          {data.enrolled_courses == null && (
            <center>
              <Preloader className="mtb-m" size="medium" />
            </center>
          )}

          {data.enrolled_courses && data.enrolled_courses.length == 0 && (
            <div className="pad-xl center">
              <img src="img/profile-course-empty.png" />
              <div className="strong font-grey mt-s">Meja Belajar Anda masih kosong</div>
            </div>
          )}
        </div>
        <Modal
          header="Hubungkan dengan akun SMILE"
          trigger={
            <Button waves="light" id="trigger-modal-email" style={{ display: "none" }}>
              Open
            </Button>
          }
        >
          <div>
            Untuk menghubungkan email {data.email}, silakan masukkan username dan password akun
            SMILE Anda
          </div>
          <LoginSmile onSubmit={this.handleSubmitForm} optionPrograms={optionPrograms} />
        </Modal>
      </div>
    )
  }
}

export default Profile



// WEBPACK FOOTER //
// ./src/components/User/Profile.js